'use strict';

angular
    .module('webmailWrapper')
    .filter('emailStatus', function (translationProvider) {

        var emailStatusList = {
            creating: translationProvider.instant('GENERAL.OBJECT.STATUS.CREATING'),
            blocked: translationProvider.instant('GENERAL.OBJECT.STATUS.BLOCKED'),
            active: translationProvider.instant('TR_060525-5542fe_TR'),
            restorable: translationProvider.instant('GENERAL.OBJECT.STATUS.RESTORABLE')
        };

        return function (input) {
            return emailStatusList[input];
        };
    });
